import { defineMessages } from 'react-intl'

export const messages = defineMessages({
  changeTime: {
    id: 'towingCommon.summaryHeader.changeTime',
    defaultMessage: 'Muuta aika',
  },
})
